import React from "react";

const NumberCard = ({ NumberData }) => {
  const data = {
    title: "Cash Flow",
    amount: "39,00,000",
    percentageChange: "+3.4%",
    note: "Good For Business",
    noteColor: "color-greenColor",
  };

  return (
    <div
      style={{
        backgroundColor: "white",
        width: "100%",
        padding: "1rem 2rem",
        borderRadius: "10px",
      }}
      className="numberDataContainer"
    >
      <h5
        style={{
          fontFamily: "Poppins-Regular",
          color: "var(--grayColor)",
          fontWeight: "500",
        }}
      >
        {NumberData?.title || data.title}
      </h5>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "1rem",
        }}
        className="numberContainer"
      >
        <h1
          style={{
            fontFamily: "Poppins-Regular",
            color: "var(--grayColor)",
            fontWeight: "500",
            fontSize: "xx-large",
          }}
        >
          {NumberData?.amount || data?.amount}
        </h1>
        <span
          className={`down ${
            parseFloat(NumberData?.percentageChange || data.percentageChange) >
            0
              ? "color-greenColor"
              : "color-redColor"
          }`}
        >
          {NumberData.percentageChange}
        </span>
        <span className={`note ${NumberData?.noteColor || data.noteColor}`}>
          {NumberData.note}
        </span>
      </div>
    </div>
  );
};

export default NumberCard;
